const FETCH_COMMUNITY_POST = 'communityPostDetail/FETCH_COMMUNITY_POST';

const LIKE_COMMUNITY_POST = 'communityPostDetail/LIKE_COMMUNITY_POST';

const FETCH_COMMUNITY_POST_FIXED_COMMENTS =
  'communityPostDetail/FETCH_COMMUNITY_POST_FIXED_COMMENTS';

const FETCH_COMMUNITY_POST_BEST_COMMENTS =
  'communityPostDetail/FETCH_COMMUNITY_POST_BEST_COMMENTS';

const FETCH_COMMUNITY_POST_COMMENTS =
  'communityPostDetail/FETCH_COMMUNITY_POST_COMMENTS';

const FETCH_COMMUNITY_POST_COMMENT =
  'communityPostDetail/FETCH_COMMUNITY_POST_COMMENT';

const POST_COMMUNITY_POST_COMMENT =
  'communityPostDetail/POST_COMMUNITY_POST_COMMENT';

const DELETE_COMMENT = 'communityPostDetail/DELETE_COMMENT';

const HIDE_COMMENT = 'communityPostDetail/HIDE_COMMENT';

const LIKE_COMMENT = 'communityPostDetail/LIKE_COMMENT';

const RESET_COMMUNITY_POST = 'communityPostDetail/RESET_COMMUNITY_POST';

const RESET_COMMENTS = 'communityPostDetail/RESET_COMMENTS';

export default {
  FETCH_COMMUNITY_POST,
  LIKE_COMMUNITY_POST,
  FETCH_COMMUNITY_POST_FIXED_COMMENTS,
  FETCH_COMMUNITY_POST_BEST_COMMENTS,
  FETCH_COMMUNITY_POST_COMMENTS,
  FETCH_COMMUNITY_POST_COMMENT,
  POST_COMMUNITY_POST_COMMENT,
  DELETE_COMMENT,
  HIDE_COMMENT,
  LIKE_COMMENT,
  RESET_COMMUNITY_POST,
  RESET_COMMENTS,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/communityPostDetail/types.js